import { render, staticRenderFns } from "./StudentReports.vue?vue&type=template&id=31209afc&"
import script from "./StudentReports.vue?vue&type=script&lang=js&"
export * from "./StudentReports.vue?vue&type=script&lang=js&"
import style0 from "./StudentReports.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StudentReports.vue"
export default component.exports